<template>
  <v-app>
    <v-app-bar app color="dark" dark>
      <v-toolbar-title>
        Layout Labelling
        <span class="text-caption ml-3" style="opacity:0.75">Main Study</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-main>
      <v-container fill-height>
        <v-row align="center" justify="center">
          <v-col cols="12">
            <v-card class="intro-card text-center">
              <h2 class="intro-title">You are ready for the main study</h2>
              <p class="intro-body mb-3">
                You will now see a series of network drawings, one at a time. For each drawing:
              </p>
              <ul class="intro-body text-left mb-4" style="max-width: 620px; margin: 0 auto 24px;">
                <li class="mb-2">
                  Find the
                  <span style="font-weight: bold; color: #1F3864;">shortest path between the two red/circled nodes</span>
                  and select its length (1 to 10).
                </li>
                <li class="mb-2">
                  Rate the effort you devoted on a scale from
                  <span style="font-weight: bold; color: #1F3864;">1 (lowest) to 9 (highest)</span>.
                </li>
                <li class="mb-2">
                  After both answers are selected, the next drawing loads automatically.
                </li>
                <li>
                  Progress is shown as <b>x / y</b> in the top bar. There is no feedback on each trial.
                </li>
              </ul>
              <p class="intro-body mb-6">
                Take your time and answer carefully. Click Start when you are ready.
              </p>
              <v-btn color="primary" :loading="loading" @click="start" class="intro-actions">
                Start main study
              </v-btn>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'MainStudyCover',
  data() {
    return {
      sessionId: this.$route.params.sessionId,
      loading: false,
    };
  },
  methods: {
    start() {
      this.loading = true;
      this.$router.replace(`/prolific/study/${this.sessionId}/main`);
    },
  },
};
</script>

<style scoped>
.intro-card {
  max-width: 1150px;
  margin-left: auto;
  margin-right: auto;
  padding: 44px !important;
}
.intro-title {
  color: #111827;
  font-weight: 700;
  font-size: 1.75rem;
  margin-bottom: 20px;
  line-height: 1.25;
}
.intro-body {
  font-size: 1.05rem;
  line-height: 1.55;
  text-align: left;
}
.intro-actions {
  margin-top: 24px;
}
</style>
